import React from "react";
import { AlertTriangle, Loader2, X } from "lucide-react";

interface CancelConfirmationModalProps {
  isOpen: boolean;
  orderNumber?: string | number;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({
  isOpen,
  orderNumber,
  loading = false,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-rose-50/50">
          <div className="flex items-center gap-2.5 text-rose-700 font-bold text-base">
            <AlertTriangle className="w-5 h-5 text-rose-600" />
            <span>Cancel Labtest Order</span>
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            className="text-gray-400 hover:text-gray-600 p-1.5 rounded-lg hover:bg-gray-200/50 transition-colors disabled:opacity-50"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content Body */}
        <div className="p-6 space-y-3 text-center sm:text-left">
          <p className="text-sm font-semibold text-gray-900">
            Are you sure you want to cancel {orderNumber ? `Order #${orderNumber}` : "this booked labtest order"}?
          </p>
          <p className="text-xs text-gray-500 leading-relaxed">
            This action will mark the lab test booking as cancelled. This process cannot be undone once confirmed.
          </p>
        </div>

        {/* Footer Actions */}
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/80 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2.5 text-xs font-semibold text-gray-700 hover:bg-gray-200 border border-gray-300 rounded-xl transition-colors disabled:opacity-50"
          >
            Keep Order
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="px-5 py-2.5 text-xs font-bold text-white bg-rose-600 hover:bg-rose-700 rounded-xl disabled:opacity-50 flex items-center gap-2 shadow transition-all"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            <span>Yes, Cancel Order</span>
          </button>
        </div>
      </div>
    </div>
  );
};
